import React from 'react';

import InfoContainer from '../components/InfoContainer';

const AboutMe = () => {
    return (
        <InfoContainer>
            <div className={'info-container'}>
                <div className={'scroll-text'}>
                    <h1 style={{ marginTop: 70 }}>Gihan Graphics</h1>
                    <p>My name is Gihan Tharanga, and I'm a graphic designer and illustrator. I do Social media post design,logo design, Flyers / Banner design, and other Photoshop editings. Also as Illustrator, I do 2D illustrations and children's book illustrations. Currently, I am working as a freelancer.</p>
                    <p>I have been designing since 2019. Not only that I followed two online courses about design. So I think I
                        have enough experience and education about this field.</p>
                    <p>As a freelancer, I worked with clients such as the USA, Australia Mexico and Sri Lanka.</p>
                    <p>I'm always looking for new challenges and new people to meet. Don’t hesitate to contact me.</p>
                </div>
            </div>
        </InfoContainer>
    )
}
export default AboutMe;